/* eslint-disable no-param-reassign */
import produce from 'immer';

import { CHECKPIN_ERROR } from '../actions/setCheckPinActions';


const initialState = {
  errorPin: {},
  isSuccessSignIn: {}
};

const checkPinReducer = (state = initialState, action) => {
  switch (action.type) {

    case CHECKPIN_ERROR: {
      const { errorPin } = action.payload;
      return produce(state, (draft) => {
        draft.errorPin = errorPin;
      });
    }

    default: {
      return state;
    }
  }
};

export default checkPinReducer;
